<app-order-point-base-form
  class="form"
  [form]="form()"
  [isCompleted]="isCompleted()"
  [disabled]="disabled()"
></app-order-point-base-form>

<div class="goods-heading">
  <onyx-input-label
    [label]="`${I18N}.goodsToUnload` | translate"
  ></onyx-input-label>

  <onyx-link
    [class.hidden]="!hasAnyGoodsAvailable()"
    color="blue"
    font="f-body-xs f-medium"
    (click)="unloadActiveGoods()"
  >
    @if (hasAllGoodsAvailable()) {
      {{ `${I18N}.unloadAll` | translate }}
    } @else {
      {{ `${I18N}.unloadActive` | translate }}
    }
  </onyx-link>
</div>

<div class="goods" [class.invalid]="hasEmptyGoods()">
  @for (good of goods(); track good.good.uuid) {
    <app-order-unloading-point-form-good
      [good]="good"
      [form]="goodForms().get(good.good.uuid) ?? null"
      (add)="addGood(good)"
      (remove)="removeGood(good.good.uuid)"
    ></app-order-unloading-point-form-good>
  } @empty {
    <p class="empty">{{ `${I18N}.empty` | translate }}</p>
  }
</div>

@if (hasEmptyGoods()) {
  <p class="error f-body-xs f-medium">{{ `${I18N}.emptyError` | translate }}</p>
}

<app-order-point-information-form
  [form]="form()"
></app-order-point-information-form>
